export default "__VITE_ASSET__Ccpjn8aw__"